/* ============================================
   POSHRUG — Global JavaScript
   ============================================ */

// ── ACCORDION ──
function poshAccordionInit() {
  document.querySelectorAll('.posh-accordion__trigger').forEach(btn => {
    btn.addEventListener('click', function() {
      const body = this.nextElementSibling;
      const isOpen = this.classList.contains('open');
      this.classList.toggle('open', !isOpen);
      body.classList.toggle('open', !isOpen);
    });
  });
}

// ── GUIDE TOGGLES ──
function poshGuideInit() {
  document.querySelectorAll('.posh-guide-toggle').forEach(btn => {
    btn.addEventListener('click', function() {
      const panel = this.nextElementSibling;
      const isOpen = this.classList.contains('open');
      this.classList.toggle('open', !isOpen);
      panel.classList.toggle('open', !isOpen);
    });
  });
}

// ── TRADE POPUP ──
function poshTradePopupInit() {
  window.openTradePopup = function() {
    document.getElementById('poshTradePopup').classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  window.closeTradePopup = function() {
    document.getElementById('poshTradePopup').classList.remove('open');
    document.body.style.overflow = '';
  };
  const overlay = document.getElementById('poshTradePopup');
  if (overlay) {
    overlay.addEventListener('click', function(e) {
      if (e.target === this) closeTradePopup();
    });
  }
}

// ── SWATCH SELECTOR ──
function poshSwatchInit() {
  document.querySelectorAll('.posh-swatch').forEach(s => {
    s.addEventListener('click', function() {
      const group = this.closest('.posh-swatch-row');
      group.querySelectorAll('.posh-swatch').forEach(x => x.classList.remove('active'));
      this.classList.add('active');
      const label = group.querySelector('.posh-swatch-label');
      if (label) label.textContent = this.getAttribute('title') || '';
    });
  });
}

// ── VARIANT CHIPS ──
function poshVariantInit() {
  document.querySelectorAll('.posh-variant-chip').forEach(chip => {
    chip.addEventListener('click', function() {
      const grid = this.closest('.posh-variant-grid');
      grid.querySelectorAll('.posh-variant-chip').forEach(x => x.classList.remove('active'));
      this.classList.add('active');
      // Update dynamic spec fields if they exist
      const sizeMap = this.dataset.dimensions;
      const weightMap = this.dataset.weight;
      if (sizeMap) {
        const sizeEl = document.getElementById('posh-spec-size');
        if (sizeEl) sizeEl.textContent = sizeMap;
      }
      if (weightMap) {
        const weightEl = document.getElementById('posh-spec-weight');
        if (weightEl) weightEl.textContent = weightMap;
      }
    });
  });
}

// ── GALLERY THUMBS ──
function poshGalleryInit() {
  document.querySelectorAll('.posh-thumb').forEach(thumb => {
    thumb.addEventListener('click', function() {
      const gallery = this.closest('.posh-gallery');
      gallery.querySelectorAll('.posh-thumb').forEach(x => x.classList.remove('active'));
      this.classList.add('active');
      const mainImg = gallery.querySelector('.posh-gallery__main img');
      const src = this.dataset.src;
      if (mainImg && src) mainImg.src = src;
    });
  });
}

// ── TRADE FORM ──
// The trade popup now uses Shopify's {% form 'customer' %}, which creates a
// real, subscribed customer tagged 'trade-enquiry' and redirects back with
// ?customer_posted=true. We intentionally do NOT preventDefault here — the
// form submits natively. We only give light submit feedback.
function poshTradeFormInit() {
  const form = document.getElementById('poshTradeForm');
  if (!form) return;
  form.addEventListener('submit', function() {
    const btn = form.querySelector('.posh-popup__submit');
    if (btn) {
      btn.textContent = 'Sending...';
      btn.disabled = true;
    }
  });
}

// ── STYLE QUIZ ──
// Modal with 4 style choices. Picking a style sets the hidden contact[tags]
// value to 'quiz-{type},newsletter' and reveals the email step. The customer
// form then creates a real, subscribed customer with those tags.
const POSH_QUIZ_STYLES = {
  sisal: 'Sisal',
  patchwork: 'Patchwork',
  cowhide: 'Cowhide',
  sheepskin: 'Sheepskin'
};

function poshStyleQuizInit() {
  window.openStyleQuiz = function() {
    const el = document.getElementById('poshStyleQuiz');
    if (!el) return;
    el.classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  window.closeStyleQuiz = function() {
    const el = document.getElementById('poshStyleQuiz');
    if (!el) return;
    el.classList.remove('open');
    document.body.style.overflow = '';
  };
  window.poshQuizPick = function(type) {
    const tagsInput = document.getElementById('poshQuizTags');
    if (tagsInput) tagsInput.value = 'quiz-' + type + ',newsletter';
    const nameEl = document.getElementById('poshQuizChosenName');
    if (nameEl) nameEl.textContent = POSH_QUIZ_STYLES[type] || type;
    const s1 = document.getElementById('poshQuizStep1');
    const s2 = document.getElementById('poshQuizStep2');
    if (s1) s1.style.display = 'none';
    if (s2) s2.style.display = 'block';
    const email = document.getElementById('quiz_email');
    if (email) email.focus();
  };
  window.poshQuizBack = function() {
    const s1 = document.getElementById('poshQuizStep1');
    const s2 = document.getElementById('poshQuizStep2');
    if (s1) s1.style.display = 'block';
    if (s2) s2.style.display = 'none';
  };

  const overlay = document.getElementById('poshStyleQuiz');
  if (overlay) {
    overlay.addEventListener('click', function(e) {
      if (e.target === this) closeStyleQuiz();
    });
  }

  // Light submit feedback (form submits natively).
  const quizForm = document.getElementById('poshQuizForm');
  if (quizForm) {
    quizForm.addEventListener('submit', function() {
      const btn = quizForm.querySelector('.posh-popup__submit');
      if (btn) {
        btn.textContent = 'Sending...';
        btn.disabled = true;
      }
    });
  }

  // Auto-open when the URL contains ?quiz=1 (welcome email links to /?quiz=1).
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('quiz') === '1' && overlay) {
      window.openStyleQuiz();
    }
  } catch (e) {}
}

// ── INIT ALL ──
document.addEventListener('DOMContentLoaded', function() {
  poshAccordionInit();
  poshGuideInit();
  poshTradePopupInit();
  poshSwatchInit();
  poshVariantInit();
  poshGalleryInit();
  poshTradeFormInit();
  poshStyleQuizInit();
});
